import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import classNames from "classnames";
// import pdffile4 from "/assets/downloadpdf/NavIC-Timing-Server.pdf";
// import pdffile1 from "../../assets/downloadpdf/Elena-E1A-Chip.pdf";
// import pdffile2 from "/assets/downloadpdf/ElenaHHNN.pdf";
// import pdffile3 from "/assets/downloadpdf/GC.pdf";
// const pdffile4 = "/assets/downloadpdf/NavIC-Timing-Server.pdf";
// const pdffile1 = "/assets/downloadpdf/Elena-E1A-Chip.pdf";
// const pdffile2 = "/assets/downloadpdf/ElenaHHNN.pdf";
// const pdffile3 = "/assets/downloadpdf/GC.pdf";
import image1 from "../../assets/images/about/e1a.png";
import image2 from "../../assets/images/about/hhn.png";
import image3 from "../../assets/images/about/GC_43.png";
import image4 from "../../assets/images/about/timingserver.png";

export default function SliderComp() {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 8000,
    pauseOnHover: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };

  const sections = [
    {
      span: "PNT solutions For all applications",
      heading:
        "India's first NavIC based Multi GNSS processor for precise applications",
      content:
        " High-precision NavIC processor enables accurate navigation and positioning using India's indigenous satellite navigation system.",
      more: "/multi/0",
      listContent: [
        "Make in India",
        "Multi-Constellation",
        "Embedded Processing",
        "High-Precision",
      ],
      imageCustomClass: "",
      imgUrl: image1,
    },
    {
      heading: "NavIC Handheld Navigator",
      content:
        "A state-of-the-art Elena Handheld Navigator (EHHN) with cutting-edge technology that provides precise and reliable multi-GNSS based navigation using the NavIC (Navigation with Indian Constellation) system.",
      more: "/handheld-navigator/10",

      listContent: [
        <div style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
          Supports L1, L5 band{" "}
        </div>,
        "Accurate positioning",
        "Dedicated R&D",
        "Tested in all terrains",
      ],
      imageCustomClass: "mr-4",
      imgUrl: image2,
    },
    {
      heading: "Elena Grid Converter",
      content:
        "This Grid Converter is state-of-the-art positioning equipment made using Elena's Multi-GNSS processor, which utilizes NavIC, GPS, and GLONASS to provide one-meter accuracy without any external support.",
      more: "grid-converter/9",

      listContent: [
        <div style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
          Location in ESM GR,DSM GR{" "}
        </div>,
        "Battery - 60 hours",
        "Accurate navigation",
        "Highly secure",
      ],

      imgUrl: image3,
    },
    {
      heading: "NavIC Timing Server",
      content:
        "The NavIC Timing Server is specialized solution developed by Elena Geo Tech to cater for Indian needs.This is aculmination of Elena Geo's Effort from August 2021,whence we were identified by Department of Telecommunication and were funded to develop NavIC timing circuits.",
      more: "timing-server/8",

      listContent: [
        <div style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
          Supports L1, L5, S band{" "}
        </div>,
        "Time pulse",
        "Programmable time",
        "Timing signal - 10 Mhz",
      ],

      imgUrl: image4,
    },
    // {
    //   heading: "Heading 2",
    //   content: "Another section of content.",
    //   moreFile: "/files/sample2.pdf",
    //   content1: "Item A",
    //   content2: "Item B",
    //   content3: "Item C",
    //   content4: "Item D",
    //   imgUrl: "../assets/images/about/GR_4.png",
    // },
    // Add more objects as needed
  ];

  // The same content block will be repeated
  // const content = (
  //   <div className="row align-items-center bg-black d-flex pl-4 pr-5 ms-2 py-5 slider-cont ">
  //     <div className="col-lg-6 " style={{ placeItems: "center" }}>
  //       <div className="about-image-shape rmb-70 wow fadeInLeft delay-0-2s w-100">
  //         <img
  //           src={require(`../../assets/images/about/e1a.png`).default}
  //           alt="About"
  //           style={{ width: "465px" }}
  //         />
  //       </div>
  //     </div>
  //     <div className="col-lg-6">
  //       <div className="about-content text-white pr-70 rpr-0 wow fadeInRight delay-0-2s ">
  //         <div className="section-title mb-35">
  //           <span className="sub-title">
  //             PNT solutions For all applications
  //           </span>
  //           <h2>
  //             India's first NavIC based Multi GNSS processor for precise
  //             applications
  //           </h2>
  //         </div>
  //         <p>
  //           High-precision NavIC processor enables accurate navigation and
  //           positioning using India's indigenous satellite navigation system.
  //           <a
  //             href={pdffile1}
  //             target="_blank"
  //             rel="noreferrer"
  //             className="ml-1"
  //             download
  //             style={{ color: "white", textDecoration: "underline" }}
  //           >
  //             More
  //           </a>
  //         </p>
  //         <ul className="list-style-one mt-15">
  //           <li>Make in India</li>
  //           <li>Multi-Constellation</li>
  //           <li>Embedded Processing</li>
  //           <li>High-Precision</li>
  //         </ul>
  //       </div>
  //     </div>
  //   </div>
  // );
  // const Gridcontent = (
  //   <div className="row align-items-center bg-black d-flex pl-4 pr-5 ms-2 py-5 slider-cont">
  //     <div className="col-lg-6" style={{ placeItems: "center" }}>
  //       <div className="about-image-shape rmb-70 wow fadeInLeft delay-0-2s hhn-border-radius  w-100">
  //         <img
  //           src={require(`../../assets/images/about/GR_4.png`).default}
  //           alt="About"
  //           className="slider-grid"
  //         />
  //       </div>
  //     </div>
  //     <div className="col-lg-6">
  //       <div className="about-content text-white pr-70 rpr-0 wow fadeInRight delay-0-2s">
  //         <div className="section-title mb-35">
  //           {/* <span className="sub-title">Grid</span> */}
  //           <h2>Elena Grid Converter</h2>
  //         </div>
  //         <p>
  //           This Grid Converter is state-of-the-art positioning equipment made
  //           using Elena's Multi-GNSS processor, which utilizes NavIC, GPS, and
  //           GLONASS to provide one-meter accuracy without any external support.{" "}
  //           <a
  //             target="_blank"
  //             href={pdffile3}
  //             rel="noreferrer"
  //             className="ml-1"
  //             download
  //             style={{ color: "white", textDecoration: "underline" }}
  //           >
  //             More
  //           </a>
  //         </p>
  //         <ul className="list-style-one mt-15 ">
  //           <li>
  //             <div style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
  //               Location in ESM GR,DSM GR
  //             </div>
  //           </li>
  //           <li>Battery - 60 hours</li>
  //           <li>Accurate navigation</li>
  //           <li>Highly secure</li>
  //         </ul>
  //       </div>
  //     </div>
  //   </div>
  // );
  // const Servercontent = (
  //   <div className="row align-items-center bg-black d-flex pl-4 pr-5 ms-2 py-5 slider-cont">
  //     <div className="col-lg-6 order-2">
  //       <div className="about-content text-white pr-70 rpr-0 wow fadeInRight delay-0-2s">
  //         <div className="section-title mb-35">
  //           {/* <span className="sub-title">Grid</span> */}
  //           <h2>NavIC Timing Server</h2>
  //         </div>
  //         <p>
  //           The NavIC Timing Server is specialized solution developed by Elena
  //           Geo Tech to cater for Indian needs.This is aculmination of Elena
  //           Geo's Effort from August 2021,whence we were identified by
  //           Department of Telecommunication and were funded to develop NavIC
  //           timing circuits.{" "}
  //           <a
  //             href={pdffile4}
  //             target="_blank"
  //             rel="noreferrer"
  //             className="ml-1"
  //             download
  //             style={{ color: "white", textDecoration: "underline" }}
  //           >
  //             More
  //           </a>
  //         </p>
  //         <ul className="list-style-one mt-15">
  //           <li className="grid-border-radius">
  //             <div style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
  //               Supports L1, L5, S band
  //             </div>
  //           </li>
  //           <li className="grid-border-radius">Time pulse</li>
  //           <li className="grid-border-radius">Programmable time</li>
  //           <li className="grid-border-radius">Timing signal - 10 Mhz</li>
  //         </ul>
  //       </div>
  //     </div>
  //     <div className="col-lg-6" style={{ placeItems: "center" }}>
  //       <div className="about-image-shape rmb-70 wow fadeInLeft delay-0-2s grid-border-radius w-100">
  //         <img
  //           src={require(`../../assets/images/about/timingserver.png`).default}
  //           alt="About"
  //           className=""
  //           style={{ width: "450px", padding: "4em 2em" }}
  //         />
  //       </div>
  //     </div>
  //   </div>
  // );
  // const HandHeldcontent = (
  //   <div className="row align-items-center bg-black d-flex pl-4 pr-5 ms-2 pt-4 py-5 slider-cont">
  //     <div className="col-lg-6 order-2">
  //       <div className="about-content text-white pr-70 rpr-0 wow fadeInRight delay-0-2s">
  //         <div className="section-title mb-35">
  //           {/* <span className="sub-title">Grid</span> */}
  //           <h2>NavIC Handheld Navigator</h2>
  //         </div>
  //         <p>
  //           A state-of-the-art Elena Handheld Navigator (EHHN) with cutting-edge
  //           technology that provides precise and reliable multi-GNSS based
  //           navigation using the NavIC (Navigation with Indian Constellation)
  //           system.{" "}
  //           <a
  //             href={pdffile2}
  //             target="_blank"
  //             rel="noreferrer"
  //             className="ml-1"
  //             download
  //             style={{ color: "white", textDecoration: "underline" }}
  //           >
  //             More
  //           </a>
  //         </p>
  //         <ul className="list-style-one mt-15">
  //           <li className="grid-border-radius">
  //             <div style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
  //               Supports L1, L5 band
  //             </div>
  //           </li>
  //           <li className="grid-border-radius">Accurate positioning</li>
  //           <li className="grid-border-radius">Dedicated R&D</li>
  //           <li className="grid-border-radius">Tested in all terrains</li>
  //         </ul>
  //       </div>
  //     </div>
  //     <div className="col-lg-6" style={{ placeItems: "center" }}>
  //       <div className="about-image-shape rmb-70 wow fadeInLeft delay-0-2s grid-border-radius w-100">
  //         <img
  //           src={require(`../../assets/images/about/hhn.png`).default}
  //           alt="About"
  //           className="slider-hhn"
  //         />
  //       </div>
  //     </div>
  //   </div>
  // );
  const isMobile = window.innerWidth <= 850;

  const truncateText = (text, limit = 100) => {
    if (isMobile && text.length > limit) {
      return `${text.slice(0, limit).trim()}...`;
    }
    return text;
  };

  return (
    <section className="">
      <div className="d-non">
        <Slider {...settings} className="w-100">
          {/* {content}
          {HandHeldcontent}
          {Gridcontent}
          {Servercontent} */}
          {sections.map((item, index) => (
            <div
              key={index}
              className="row align-items-center bg-black text-white d-flex pl-4 pr-5 pt-4 py-5 slider-cont"
              style={{ minHeight: "100vh" }}
            >
              {/* Left Text Column */}
              <div className="col-12 col-lg-6 order-2  ">
                <div className="about-content pr-lg-5">
                  <div className="section-title mb-4">
                    <span className="sub-title">{item?.span}</span>
                    <h2>{item.heading}</h2>
                  </div>
                  <p>
                    {truncateText(item.content)}{" "}
                    <Link
                      className="ml-1"
                      to={item.more}
                      style={{ color: "white", textDecoration: "underline" }}
                    >
                      More
                    </Link>
                  </p>

                  <ul className="list-style-one mt-3">
                    {item.listContent.map((val) => (
                      <li
                        className="grid-border-radius mb-1 col-12 col-lg-6"
                        style={{ fontSize: "0.85rem" }}
                      >
                        {val}
                      </li>
                    ))}
                    {/* <li className="grid-border-radius mb-2">
                      <div style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                        {item.content1}
                      </div>
                    </li>
                    <li className="grid-border-radius mb-2">{item.content2}</li>
                    <li className="grid-border-radius mb-2">{item.content3}</li>
                    <li className="grid-border-radius">{item.content4}</li> */}
                  </ul>
                </div>
              </div>

              {/* Right Image Column */}
              <div className="col-12 col-lg-6 order-1  d-flex justify-content-center align-items-center slider-mob-img">
                <div className="about-image-shape w-100 grid-border-radius">
                  <img
                    src={item.imgUrl}
                    alt="About"
                    className={classNames("img-fluid ", item.imageCustomClass)}
                    style={{
                      objectFit: "cover",
                      padding: "2.5em",
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="d-none">
        <Slider {...settings} className="w-100">
          {sections.map((item, index) => (
            <div
              key={index}
              className="row align-items-center bg-black text-white px-4 py-4 d-flex flex-row"
              style={{
                // background: `url(${item.imgUrl})`,
                overflow: "hidden", // prevents overflow if content is larger than 40vh
              }}
            >
              {/* Left Column: Heading and Content */}
              <div className="col-12 col-lg-6 mb-4 mb-lg-0 d-flex flex-column justify-content-center ">
                <div className="about-content pr-lg-5 pl-lg-10">
                  <div className="section-title mb-3">
                    {item?.span && (
                      <span className="sub-title">{item.span}</span>
                    )}
                    <h2 style={{ fontSize: "1.5rem" }}>{item.heading}</h2>
                  </div>
                  <p className="mb-0" style={{ fontSize: "0.9rem" }}>
                    {item.content}{" "}
                    <Link
                      className="ml-1"
                      to={item.more}
                      style={{ color: "white", textDecoration: "underline" }}
                    >
                      More
                    </Link>
                  </p>
                </div>
              </div>

              {/* Right Column: List Items */}
              <div className="col-12 col-lg-6 d-flex flex-column justify-content-center">
                <ul className="list-style-one mt-3 mb-0 row">
                  {item.listContent.map((val) => (
                    <li
                      className="grid-border-radius mb-1 col-12 col-lg-6"
                      style={{ fontSize: "0.85rem" }}
                    >
                      {val}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
